/* Aurazio theme — global interactions */

document.addEventListener('DOMContentLoaded', function () {
  /* ---- Mobile drawer ---- */
  var toggle = document.querySelector('[data-menu-toggle]');
  var drawer = document.querySelector('[data-drawer]');
  var drawerOverlay = document.querySelector('[data-drawer-overlay]');
  var drawerClose = document.querySelector('[data-drawer-close]');

  function openDrawer() {
    if (drawer) drawer.classList.add('is-open');
    if (drawerOverlay) drawerOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    if (drawer) drawer.classList.remove('is-open');
    if (drawerOverlay) drawerOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (toggle) toggle.addEventListener('click', openDrawer);
  if (drawerClose) drawerClose.addEventListener('click', closeDrawer);
  if (drawerOverlay) drawerOverlay.addEventListener('click', closeDrawer);

  /* ---- Newsletter popup ---- */
  var popup = document.querySelector('[data-popup]');
  var popupClose = document.querySelector('[data-popup-close]');

  if (popup) {
    var seen = false;
    try { seen = window.sessionStorage.getItem('aurazio_popup_seen') === '1'; } catch (e) {}

    if (!seen) {
      setTimeout(function () {
        popup.classList.add('is-open');
      }, 4000);
    }

    function dismissPopup() {
      popup.classList.remove('is-open');
      try { window.sessionStorage.setItem('aurazio_popup_seen', '1'); } catch (e) {}
    }

    if (popupClose) popupClose.addEventListener('click', dismissPopup);
    popup.addEventListener('click', function (e) {
      if (e.target === popup) dismissPopup();
    });
  }

  /* ---- Countdown ---- */
  var countdowns = document.querySelectorAll('[data-countdown]');
  countdowns.forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) return;

    var dEl = el.querySelector('[data-cd-days]');
    var hEl = el.querySelector('[data-cd-hours]');
    var mEl = el.querySelector('[data-cd-mins]');
    var sEl = el.querySelector('[data-cd-secs]');

    function pad(n) { return n < 10 ? '0' + n : '' + n; }

    function tick() {
      var now = new Date().getTime();
      var diff = target - now;
      if (diff < 0) { diff = 0; }
      var days = Math.floor(diff / 86400000);
      var hours = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (dEl) dEl.textContent = pad(days);
      if (hEl) hEl.textContent = pad(hours);
      if (mEl) mEl.textContent = pad(mins);
      if (sEl) sEl.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  });

  /* ---- Scroll reveal (wave effect) ---- */
  var prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!prefersReduced && 'IntersectionObserver' in window) {
    var revealSelectors = [
      '.section-header',
      '.hero__overlay > *',
      '.image-banner__overlay > *',
      '.image-with-text-section .feature__content > *',
      '.rich-text__inner > *',
      '.card',
      '.usp-slide',
      '.pdp-acc__item',
      '.feature__content > *',
      '.commitment__inner > *'
    ];

    var revealEls = [];
    revealSelectors.forEach(function (sel) {
      var found = document.querySelectorAll(sel);
      for (var i = 0; i < found.length; i++) {
        if (revealEls.indexOf(found[i]) === -1) revealEls.push(found[i]);
      }
    });

    revealEls.forEach(function (el) { el.classList.add('reveal'); });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var parent = el.parentElement;
          var siblings = parent ? Array.prototype.filter.call(parent.children, function (c) { return c.classList.contains('reveal'); }) : [el];
          var idx = siblings.indexOf(el);
          if (idx < 0) idx = 0;
          var delay = Math.min(idx, 6) * 90;
          el.style.transitionDelay = delay + 'ms';
          el.classList.add('reveal--in');
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });

    revealEls.forEach(function (el) { observer.observe(el); });
  }
});
